import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = { class: "text-nowrap pr-3 min-width-0" }
const _hoisted_3 = { class: "p-0 m-0 text-white" }
const _hoisted_4 = { class: "mt-2 text-truncate lh-primary" }
const _hoisted_5 = { class: "flex-fill text-right" }

import {
    AudioMessageEventPayloadInterface
} from "~/operatorApplication/vue/dialogs/dialog/DialogChatAreaExposeInterface";
import {onBeforeUnmount, onMounted} from "vue";
import {
    AUDIO_BUTTON_PLAY_EVENT,
    AUDIO_PLAY_BUTTON_DISABLE_PAUSE_ON_UNMOUNT, AudioButtonPlayEventInterface
} from "~/cabinet/vue/interface/data/IAudioPlayButton";
import {addDisposableEvent} from "~/ts/vuePlugins/useDisposableEvent";
import Events from "~/ts/library/Events";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApplicationBuddyList from "~/operatorApplication/ts/service/OperatorApplicationBuddyList";
import {EventManagerInstance} from "~/cabinet/ts/Constant";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "BuddyListCurrentAudio"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    e: {}
  },
  emits: ["ended"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

onMounted(() => {
    props.e.audio.setAttribute(AUDIO_PLAY_BUTTON_DISABLE_PAUSE_ON_UNMOUNT, "1");
    addDisposableEvent(
        EventManagerInstance.addEventListener(AUDIO_BUTTON_PLAY_EVENT, (e: AudioButtonPlayEventInterface) => {
            if (e.audio != props.e.audio) {
                stop();
            }
        })
    );
});

function emitEnded() {
    emits('ended', props.e);
}

addDisposableEvent(Events.addEventListener("ended", props.e.audio, emitEnded));
addDisposableEvent(Events.addEventListener("pause", props.e.audio, emitEnded));


onBeforeUnmount(() => {
    props.e.audio.removeAttribute(AUDIO_PLAY_BUTTON_DISABLE_PAUSE_ON_UNMOUNT);
});

function stop() {
    try {
        props.e.audio.pause();
    } catch (e) {

    }
    emitEnded();
}

async function goToClient() {
    await OperatorApplicationBuddyList.addClientAndOpenByUsername(props.e.client.username);
}

return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "d-flex w-100 align-items-center audio h-auto el-button text-left",
      onClick: goToClient
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", _hoisted_3, _toDisplayString(_unref(__)('Аудио-файл')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(props).e.client.displayDescr), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createVNode(FontAwesomeIcon, { icon: "times" }, null, 512), [
          [
            _directive_on_native,
            stop,
            "click",
            { stop: true }
          ]
        ])
      ])
    ])
  ]))
}
}

})